/** Dispatched by Pet Friendly amenity links; Footer listens and opens the pet-policy popup. */
export const OPEN_PET_POLICY_MODAL_EVENT = 'vibesite:open-pet-policy-modal';

export function requestOpenPetPolicyModal(e?: { preventDefault?: () => void }) {
  e?.preventDefault?.();
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_PET_POLICY_MODAL_EVENT));
}

/** Match amenity titles that should open the pet-policy popup. */
export function isPetFriendlyAmenityTitle(title: string | null | undefined): boolean {
  if (!title) return false;
  const normalized = title.trim().toLowerCase().replace(/[\s_-]+/g, '');
  return normalized === 'petfriendly' || normalized.startsWith('petfriendly');
}
